import {
  Button,
  BUTTON_SIZE_LG,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Card,
  Text,
  Title,
  TITLE_VARIANT_M,
  TITLE_VARIANT_XL,
  Tooltip,
  TooltipUtils
} from 'mailup-web-components'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import Header from './Header'

import evalCondition from 'Helpers/evalCondition'
import { canUseMshop } from 'Helpers/mshopHelpers'
import { notifyParent } from 'Helpers/notifyParent'
import { isOfferLight } from 'Helpers/options'

import './NewMessage.scss'

import backgroundImage from 'Img/visual_create_email.png'

const NewMessage = () => {
  const intl = useIntl()
  const history = useHistory()

  const beeActive = evalCondition('co:BEEEDITORENABLE AND uo:BEEEDITORENABLE')

  const offerLight = isOfferLight()
  const hasMshop = canUseMshop()

  const ctaTip = offerLight ? 'offer-light-upsell' : undefined

  const options = [
    {
      onClick: () => {
        notifyParent('redirectMainFrame', ['template_list.aspx?source=create'])
      },
      text: intl.formatMessage({
        id: 'Load.NewEmailWizard.NewFromTemplateDescription'
      }),
      title: undefined,
      cta: intl.formatMessage({ id: 'Load.NewEmailWizard.Template' }),
      ctaDisabled: offerLight,
      ctaTip,
      className: 'test-newEmailWizard-Template',
      dataAttributeTest: 'new-email-template'
    },
    {
      onClick: () => {
        history.push('/messages/email/import/file')
      },
      text: intl.formatMessage({
        id: 'Load.NewEmailWizard.NewFromFileDescription'
      }),
      title: undefined,
      cta: intl.formatMessage({ id: 'Load.NewEmailWizard.File' }),
      ctaDisabled: offerLight,
      ctaTip,
      className: 'test-newEmailWizard-File',
      dataAttributeTest: 'new-email-file'
    },
    {
      onClick: () => {
        history.push('/messages/email/import/url')
      },
      text: intl.formatMessage({
        id: 'Load.NewEmailWizard.NewFromUrlDescription'
      }),
      title: undefined,
      cta: intl.formatMessage({ id: 'Load.NewEmailWizard.Url' }),
      ctaDisabled: offerLight,
      ctaTip,
      className: 'test-newEmailWizard-Url',
      dataAttributeTest: 'new-email-url'
    },
    {
      onClick: () => {
        notifyParent('redirectMainFrame', ['form_ins_newsletterRSS.aspx'])
      },
      text: intl.formatMessage({
        id: 'Load.NewEmailWizard.NewFromRssDescription'
      }),
      title: undefined,
      cta: intl.formatMessage({ id: 'Load.NewEmailWizard.RSS' }),
      ctaDisabled: offerLight,
      ctaTip,
      className: 'test-newEmailWizard-RSS',
      dataAttributeTest: 'new-email-rss'
    }
  ]

  if (beeActive) {
    options.unshift({
      title: undefined,
      cta: intl.formatMessage({ id: 'Load.NewEmailWizard.Nuovo' }),
      ctaDisabled: offerLight,
      ctaTip,
      onClick: () => {
        notifyParent('redirectMainFrame', ['form_ins_newsletter.aspx'])
      },
      text: intl.formatMessage({
        id: 'Load.NewEmailWizard.NewFromHtmlEditorDescription'
      }),
      className: 'test-newEmailWizard-scratch',
      dataAttributeTest: 'new-email-scratch'
    })
    options.unshift({
      title: undefined,
      cta: intl.formatMessage({ id: 'Load.NewEmailWizard.NewDrag&Drop' }),
      onClick: () => {
        history.push('/templates/bee/create')
      },
      text: intl.formatMessage({
        id: 'Load.NewEmailWizard.NewDrag&DropDescription'
      }),
      className: 'test-newEmailWizard-NewDragAndDrop',
      dataAttributeTest: 'new-email-newdraganddrop'
    })
  }

  useEffect(() => {
    TooltipUtils.rebuild()
  }, [options])

  const strJumbotronHead = beeActive
    ? intl.formatMessage(
        { id: 'Load.NewEmailWizard.BeeStartTitle' },
        { span: str => <span>{str}</span> }
      )
    : intl.formatMessage(
        { id: 'Load.NewEmailWizard.NewEmailStartTitle' },
        { span: str => <span>{str}</span> }
      )
  const strJumbotronText = beeActive
    ? intl.formatMessage(
        { id: 'Load.NewEmailWizard.BeeStartSubTitle' },
        { span: str => <span>{str}</span> }
      )
    : intl.formatMessage(
        { id: 'Load.NewEmailWizard.NewEmailStartSubTitle' },
        { span: str => <span>{str}</span> }
      )
  const strJumbotronCta = intl.formatMessage({
    id: 'Load.NewEmailWizard.CreateNewEmail'
  })
  const handleClickJumbotronCta = beeActive
    ? () => history.push('/templates/bee/create')
    : () => notifyParent('redirectMainFrame', ['form_ins_newsletter.aspx'])

  return (
    <div className='t-new-message'>
      <Header />
      <Tooltip />
      <TooltipUtils
        id='offer-light-upsell'
        type='light'
        effect='solid'
        className='c-tooltip'
      >
        {intl.formatMessage(
          { id: 'Load.BaseConfigUpsell.NoFeatureTooltip' },
          {
            linebreak: <br />,
            strong: chunks => <strong>{chunks}</strong>,
            BUY: (
              <strong>
                {hasMshop
                  ? intl.formatMessage({
                      id: 'Load.BaseConfigUpsell.NoFeatureTooltipMshop'
                    })
                  : intl.formatMessage({
                      id: 'Load.BaseConfigUpsell.NoFeatureTooltipNoMshop'
                    })}
              </strong>
            )
          }
        )}
      </TooltipUtils>
      <div className='l-container'>
        <section>
          <header
            className='t-new-message__jumbotron'
            style={{
              backgroundImage: `url(${backgroundImage})`
            }}
            data-mu-test='jumbotron'
          >
            <div className='t-new-message__jumbotron__inner'>
              <Title variant={TITLE_VARIANT_XL}>{strJumbotronHead}</Title>
              <Text htmlElement='p'>{strJumbotronText}</Text>
              <Button
                kind={BUTTON_VARIANT_PRIMARY}
                size={BUTTON_SIZE_LG}
                onClick={handleClickJumbotronCta}
                data-mu-test='new-email-newdraganddrop-cta'
              >
                {strJumbotronCta}
              </Button>
            </div>
          </header>

          <Title variant={TITLE_VARIANT_M}>
            {intl.formatMessage({
              id: 'Load.NewEmailWizard.StandardEditorBee'
            })}
          </Title>

          <ul className='t-new-message__types'>
            {options.map(
              (
                {
                  title,
                  cta,
                  ctaDisabled,
                  ctaTip,
                  text,
                  className,
                  dataAttributeTest,
                  onClick
                },
                i
              ) => (
                <li
                  className='t-new-message__type'
                  key={`new-message-option-${i}`}
                >
                  <Card
                    onClick={onClick}
                    collapsible={false}
                    className={className}
                    data-mu-test={dataAttributeTest}
                  >
                    <article className='t-new-message__type__inner'>
                      {title && (
                        <Title variant={TITLE_VARIANT_XL}>{title}</Title>
                      )}
                      <Text>{text}</Text>
                      <div
                        data-tip={ctaTip ? true : undefined}
                        data-for={ctaTip}
                      >
                        <Button
                          kind={BUTTON_VARIANT_SECONDARY}
                          disabled={ctaDisabled}
                        >
                          {cta}
                        </Button>
                      </div>
                    </article>
                  </Card>
                </li>
              )
            )}
          </ul>
        </section>
      </div>
    </div>
  )
}

export default NewMessage
